<template>
	<div>
		<ConditionalRenderingFieldDataProvider
			v-for="param in params"
			:key="param.key"
			:param="param"
			:credentialsConfiguration="credentialsConfiguration"
			:service="service"
			:paramsMap="paramsMap"
			:paramsMapLabels="paramsMapLabels"
			:contextId="context.id"
			@update-input-field="updateInputField"
			@update-input-field-label="updateInputFieldLabel"
		/>
	</div>
</template>

<script>
import ConditionalRenderingFieldDataProvider from './ConditionalRenderingFieldDataProvider.vue';
import AppActionService from '@/utils/AppActionService';
export default {
	name: 'ConditionalRenderingFieldsForm',
	props: {
		service: { type: Object },
		credentialsConfiguration: { type: Object },
		params: { type: Array },
		context: { type: Object },
		paramsMap: { type: Object },
		paramsMapLabels: { type: Object },
		addOnBaseUrl: { type: String },
	},
	components: { ConditionalRenderingFieldDataProvider },
	computed: {
		contextRegexList() {
			const regexList = this.context.regex_list;
			if (this.context?.regex && regexList.length === 0) {
				// Hack to handle .regex when regex_list is empty array.
				regexList.push(this.context?.regex);
			}
			return regexList.map((regex) => new RegExp(regex));
		},
		matchingRegex() {
			return this.contextRegexList.find((regex) => regex.test(this.addOnBaseUrl));
		},
		matchingRegexContentGroups() {
			return this.matchingRegex?.exec(this.addOnBaseUrl).groups;
		},
		baseParamsMap() {
			return this.params
				.map((p) => p.key)
				.reduce((baseParamsMap, pKey) => {
					const keyFromRegex = this.contextParams[pKey];
					const valueFromRegex = this.matchingRegexContentGroups[keyFromRegex];
					return { ...baseParamsMap, [pKey]: valueFromRegex };
				}, {});
		},
		contextParams() {
			return this.context.params;
		},
	},
	methods: {
		clearInputField(paramKey) {
			this.updateInputField({ map: { key: paramKey, value: '' } });
			this.updateInputFieldLabel({ label: { key: paramKey, value: '' } });
		},
		updateInputField(payload) {
			const { map } = payload;
			const { key, value } = map;
			this.$emit('update:paramsMap', { ...this.paramsMap, [key]: value });
			const dependentParams = this.getDependsOnParamsOfParam(key);
			this.$nextTick(() => {
				dependentParams.forEach((param) => this.clearInputField(param.key));
			});
		},
		updateInputFieldLabel(payload) {
			const { label } = payload;
			const { key, value } = label;
			this.$emit('update:paramsMapLabels', { ...this.paramsMapLabels, [key]: value });
		},
		getDependsOnParamsOfParam(paramKey) {
			return this.params.filter((param) => (AppActionService.getDependsOnOfActionParam(param) || []).includes(paramKey));
		},
	},
	mounted() {
		this.$emit('update:paramsMap', { ...this.baseParamsMap, ...this.paramsMap });
	},
};
</script>

<style lang="scss" scoped></style>
